import React from "react"
import ErrorPage from "@src/components/ui/ErrorPage"

const Page404: React.FC = () => {
  return (
    <ErrorPage
      code={404}
      title="Page Not Found"
      description="The page you are looking for does not exist or has been moved. Please check the URL or return to the home page."
      primary={{ label: "Go to Home", to: "/" }}
      secondary={{ label: "Go Back", onClick: () => window.history.back() }}
    />
  )
}

export default Page404
